(function () {
  function initFaq(root) {
    (root || document).querySelectorAll('[data-chakrikka-faq]').forEach(function (details) {
      details.classList.toggle('is-open', details.open);
      details.addEventListener('toggle', function () {
        details.classList.toggle('is-open', details.open);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFaq(document);
    });
  } else {
    initFaq(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFaq(event.target);
  });
})();
